<template>
  <div>
    <!-- Map Section -->
    <section class="tw-relative tw-w-full tw-h-[60vh] tw-overflow-hidden">
      <neuron-google-map-v2
        v-if="allMaps.length"
        v-model:markers="allMaps"
        :center="defaultCenter"
        :markerImg="markerImage"
        class="tw-absolute tw-inset-0 tw-w-full tw-h-full"
      />
    </section>

    <!-- Form Section -->
    <section class="tw-relative tw-z-50  tw-mt-8 md:tw--mt-12 tw-px-4 tw-pb-12">
      <div
        class="tw-max-w-2xl tw-mx-auto tw-shadow-lg tw-p-6 tw-bg-white md:tw-p-10"
        :class="`tw-bg-[var(--c-${vars.backgroundColor})]`"
      >
        <h1
          v-if="vars.titleText"
          class="tw-text-center  tw-text-[var(--c-primary)]"
        >
          {{ vars.titleText }}
        </h1>
        <library-form
          v-if="form"
          :form="form"
          version="v2"
          :component="component"
          :is-form-name-visible="vars.isFormNameVisibleBool"
        />
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import NeuronGoogleMapV2 from '~/components/common/NeuronGoogleMapV2.vue';

export default defineNuxtComponent({
  name: 'BranchesContact',
  mixins: [ComponentMixin],
  components: { NeuronGoogleMapV2 },

  data() {
    return {
      form: null,
    };
  },

  created() {
    this.form = this.parseFormV2(this.vars.contactForm);
  },

  computed: {
    allMaps() {
      const locations = this.groupedVariables?.locations || [];
      return Array.isArray(locations) ? locations : [];
    },
    
    defaultCenter() {
      if (this.allMaps.length > 0) {
        const firstLocation = this.allMaps[0];
        return {
          lat: firstLocation.lat || 0,
          lng: firstLocation.lng || 0
        };
      }
      
    },

    markerImage() {
      return this.allMaps.length > 0 && this.allMaps[0].marker 
        ? this.allMaps[0].marker 
        : '';
    },
  },

  watch: {
    'vars.contactForm': {
      handler(newForm) {
        if (newForm) {
          this.form = this.parseFormV2(newForm);
        }
      },
      deep: true
    }
  }
});
</script>